export default __webpack_public_path__ + "static/9-2bec11607b75e61b0821949d5e9035f4.png";